import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const apiProductsState = atom({
  key: "apiProductsState",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
